export const TIER_ENTERPRISE = "enterprise";
export const TIER_INDIVIDUAL = "individual";
export const PAYMENT_MONTHLY = "monthly";
export const PAYMENT_YEARLY = "yearly";
export const TIER_TYPES = [TIER_ENTERPRISE, TIER_INDIVIDUAL] as const;
